import { EnvironmentOperation, EnvironmentOperationLogUri } from '../../models/environment';
import { createStringIdAdapter } from './common/string-id-adapter';

export const environmentOperationAdapter = createStringIdAdapter<EnvironmentOperation>();

export const environmentOperationLogAdapter = createStringIdAdapter<EnvironmentOperationLogUri>();
